import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SimIconComponent } from './icon.component';

@NgModule({
  declarations: [SimIconComponent],
  imports: [CommonModule],
  exports: [SimIconComponent]
})
export class SimIconModule {}
